import { Component, ContentChild, EventEmitter, Input, Output, TemplateRef } from '@angular/core';

@Component({
    selector: 'smart-toolbar',
    templateUrl: './toolbar.html',
    styleUrls: ['./toolbar.scss']
})
export class SmartToolbar {

    /**
     * If true, ONLY child components marked with [start] or [end] attributes are show.
     */
    @Input()
    split: boolean;

    /**
     * If true applies the style ".compact" to use minimum margin and padding.
     * <br>
     * If false, the style ".spaced" is applied.
     */
    @Input('compact')
    isCompact: boolean;

    // @ContentChild(TemplateRef, {static: false}) 
    // template: TemplateRef<any>;

}